import { render, staticRenderFns } from "./NewWebOrder.vue?vue&type=template&id=88ab84b4&scoped=true&"
import script from "./NewWebOrder.vue?vue&type=script&lang=js&"
export * from "./NewWebOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewWebOrder.vue?vue&type=style&index=0&id=88ab84b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ab84b4",
  null
  
)

export default component.exports